/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";

interface Props {
  color?: string;
  className: any;
}

export const IconX = ({ color = "#DC2626", className }: Props): JSX.Element => {
  return (
    <svg
      className={`icons-x ${className}`}
      fill="none"
      height="16"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path className="path" d="M11 5L5 11" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path className="path" d="M5 5L11 11" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

IconX.propTypes = {
  color: PropTypes.string,
};
